import { useEffect } from 'react';
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { useAgreementsAiSearchStore } from './useAgreementsAiSearchStore';
export const useAgreementsAiSearchPartialToast = (toastTestId)=>{
    const { showWarningToast } = useOverlayContext();
    const { t: warningTexts } = useLocaleKeys('agreement.dashboard.aiSearch.warnings');
    const searchPartial = useAgreementsAiSearchStore((s)=>s.searchPartial);
    const setPartial = useAgreementsAiSearchStore((s)=>s.setPartial);
    useEffect(()=>{
        if (searchPartial) {
            showWarningToast(warningTexts.partialCoverage(), toastTestId);
            setPartial(false);
        }
    }, [
        searchPartial,
        setPartial,
        toastTestId
    ]);
};
